import { createSelector } from "@reduxjs/toolkit";
const selectSelf = (state) => state;
export const createStoreSelector = (state, slice) => createSelector(selectSelf, (state) => state[slice]);
//# sourceMappingURL=selectors.js.map